import api from "./api";

const getAllFromCorreios = async (mcm_id:string,) => {

    return await api.patch<any[]>(`/api_front/MCMEventosCorreiosCSV/${mcm_id}`,{
            DTINI: "1900-08-01T00:00:00.000Z",           
            DTFIM: "2100-08-01T00:00:00.000Z"                      
    },{
        timeout: 30000,        
        responseType: 'text'
    })
}

const getAllInJsonFromCorreios = async (mcm_id:string,) => {
    
    return await api.patch<any[]>(`/api_front/MCMEventosCorreios/${mcm_id}/0/10000`,{
        DTINI: "1900-08-01T00:00:00.000Z",           
        DTFIM: "2100-08-01T00:00:00.000Z"                      
},{
    timeout: 30000
})    
}

export { getAllFromCorreios,getAllInJsonFromCorreios }